import { SxProps, Theme } from '@mui/material';

export const registerBenefitsSx: Record<string, SxProps<Theme>> = {
	icon: { color: 'primary.light', py: '2px' },
	container: {
		backgroundColor: 'grey.50',
		width: '100%',
		height: '100%',
		borderRadius: '3px',
		p: '5px 10px 5px 8px',
		mb: '5px',
	},
	text: {
		color: 'grey.300',
	},
};
